/*
 * @Description:业务配置
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2024-03-15 18:27:58
 * @LastEditors: lijinpeng
 */
// 引入api请求方法
import { findChannelInfoByCorp } from '@/api/captain';

const state = {
  // 接口调用参数
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '名称',
        prop: 'name',
        width: 160,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-name',
      },
      {
        label: '税源地',
        prop: 'address',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '实时单费率',
        prop: 'realtimeDefaultRates',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-realtimeDefaultRates',
      },
      {
        label: '状态',
        prop: 'supportHistory',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-supportHistory',
      },
      {
        label: '操作',
        prop: '',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-status',
      },
    ],
  },
  total: 0,
  businessId: window.localStorage.businessId,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const { data } = await findChannelInfoByCorp({
      businessId: context.state.businessId,
    });
    data &&
      data.list.forEach((item, index) => {
        if (item.id == 'chuanhua' && item.supportRealtime == '2') {
          data.list.splice(index, 1);
        }
      });
    context.commit('updateListData', Object.assign({}, context.state.listData, data));
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  updatebusinessId(state, payload) {
    state.businessId = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
